import React from 'react'
import { createPortal } from 'react-dom'
import { DrawerContainer } from './DrawerContainer'

/**
 * Initialize the drawer components with secure server-provided values
 * @param {string} userId - Current user ID
 * @param {string} coursenum - Course number
 * @param {string} pageId - Current page ID
 * @param {string[]} recentPageIds - Recent page IDs visited today
 * @param {Object[]} upcomingAssessments - Upcoming assessment scope candidates
 * @param {boolean} allowAuthorTools - Whether author tools are allowed (server-validated, already converted to boolean)
 * @param {string} userRole - User's role in the course
 * @param {string} userEmail - User's email address for contact form
 * @param {boolean} assistantEnabled - Whether AI assistant is enabled for the course
 */
export function DrawerPortal({
  userId,
  coursenum,
  pageId,
  recentPageIds,
  upcomingAssessments,
  allowAuthorTools,
  userRole,
  userEmail,
  assistantEnabled,
}) {
  const [container, setContainer] = React.useState(null)

  React.useEffect(() => {
    const findContainer = () => {
      const node = document.getElementById('reader_drawers')
      if (node) {
        setContainer(node)
      } else {
        // Try again in 100ms if not yet created by IconBar
        setTimeout(findContainer, 100)
      }
    }
    findContainer()
  }, [])

  return (
    container &&
    createPortal(
      <DrawerContainer
        userId={userId}
        coursenum={coursenum}
        pageId={pageId}
        recentPageIds={recentPageIds}
        upcomingAssessments={upcomingAssessments}
        allowAuthorTools={allowAuthorTools}
        userRole={userRole}
        userEmail={userEmail}
        assistantEnabled={assistantEnabled}
      />,
      container
    )
  )
}
